<template>
	<Layout>
		<div class="rwt-portfolio-area rn-section-gap">
			<div class="container">
				<div class="row">
					<div class="col-lg-12">
						<!-- Start 标题 -->
						<div :key="titleAnimationKey" data-aos="fade-up" data-aos-delay="60">
							<SectionTitle
							    text-align="center"
							    subtitle="Products Gallery"
							    title="产 品 中 心"
							    :section-title-style="3"
							    :bread-list="breadList"
							/>
						</div>
						<!-- end 标题 -->
						
						<!-- Start 搜索框 -->
						<div :key="searchAnimationKey" class="product-search-center" data-aos="fade-up" data-aos-duration="800" data-aos-delay="120">
						    <el-select
						        v-model="searchKeyword"
						        filterable
						        remote
						        reserve-keyword
						        placeholder="搜索产品型号"
						        :remote-method="handleProductSearch"
						        :loading="searchLoading"
						        @change="handleProductSelect"
						        size="small"
						        clearable
						    >
						        <el-option
						            v-for="item in searchResults"
						            :key="item.id"
						            :label="item.PTName"
						            :value="item.id"
						        >
						            <span style="float: left">{{ item.PTName }}</span>
						            <span style="float: right; color: #8492a6; font-size: 13px;">{{ item.categoryName }}</span>
						        </el-option>
						    </el-select>
						</div>
						<!-- end 搜索框 -->
						
						<div class="rn-blog-area rn-section-gap">
							<div class="container">
								<div class="row row--30">
									<!-- Start 左侧导航 -->
									<div class="col-lg-3 mt_md--40 mt_sm--40">
										<div class="rbt-single-widget widget_categories mt--40">
										    <h3 class="title">产品类型</h3>
										    <div class="inner">
										        <div class="category-list">
										        	<aside>
										        		<ul>
										        			<li v-for="(item,index) in menuList" :key="item.slug" style="padding-bottom: 5px;">
										        				<div :class="['menu-level-1', {activeNav:item.isSelected}]" @click="showToggle(item,index)">
										        					<span class="left-content">{{ item.name }}</span>
										        					<span class="count-text" v-if="item.subItems.length > 0">{{ item.subItems.length }}</span>
										        				</div>
										        				<!-- start 次级菜单 -->
										        				<ul v-show="item.isSubShow">
										        					<li v-for="(subItem,subIndex) in item.subItems" :key="subItem.slug" style="padding-bottom: 5px;">
										        						<div :class="['menu-level-2', {activeNav:subItem.isSelected}]" @click="showToggle(subItem,subIndex)">
										        							<span class="menu-text">{{subItem.name}}</span>
										        							<span class="count-text" v-if="subItem.subItems && subItem.subItems.length > 0">{{ subItem.subItems.length }}</span>
										        						</div>
										        						<!-- start 三级菜单 -->
										        						<ul v-show="subItem.isSubShow" v-if="subItem.subItems && subItem.subItems.length > 0">
										        							<li v-for="(grandItem,grandIndex) in subItem.subItems" :key="grandItem.slug" style="padding-bottom: 5px;">
										        								<div :class="['menu-level-3', {activeNav:grandItem.isSelected}]" @click="showToggle(grandItem,grandIndex)">
										        									<span class="menu-text">{{grandItem.name}}</span>
										        								</div>
										        							</li>
										        						</ul>
										        						<!-- end 三级菜单 -->
										        					</li>
										        				</ul>
										        				<!-- end 次级菜单 -->
										        			</li>
										        		</ul>
										        	</aside>
										        </div>
										    </div>
										</div>									    
									</div>
									<!-- end 左侧导航 -->
									
									<!-- Start 右侧列表显示 -->
									<div class="col-lg-9">
										<div class="row mt_dec--30">
											<div class="col-lg-12">
												<transition name="slide-up">
													<div class="col-lg-12 mt--30 product-list-wrapper" :key="listAnimationKey">
														<!-- <BlogPost :products-intro="edgeProductsIntro" :products-intro-key="edgeProductsIntroKey" blog-post-style="2"/> -->
														<div class="rn-card box-card-style-default edge-card-list-view">
															<div class="inner">
																<div class="onlycontent">
																	<el-table :data="edgeProductsIntro" :key="edgeProductsIntroKey" border class="product-table" style="width: 100%;margin: 0 0;" :header-cell-style="headClass" @cell-click="clickSell">
																		<el-table-column prop="qrCode" label="产品" min-width="25%">
																			<template slot-scope="scope">
																				<div class="product-img-wrapper">
																					<img class="product-thumbnail" :src="scope.row.thumbnail" >
																				</div>
																			</template>
																		</el-table-column>
																		<el-table-column label="型号" width="150">
																		<template slot-scope="scope">
																			<span v-html="scope.row.PTName"></span>
																		</template>
																	</el-table-column>
																	<el-table-column label="资源" width="300">
																		<template slot-scope="scope">
																			<span v-html="scope.row.Resource"></span>
																		</template>
																	</el-table-column>
																	<el-table-column label="简介" min-width="45%">
																			<template slot-scope="scope">
																				<span v-html="scope.row.Intro"></span>
																			</template>
																		</el-table-column>
																	</el-table>
																</div>
															</div>
														</div>
													</div>
												</transition>
											</div>
										</div>
									</div>
									<!-- end 右侧列表显示 -->
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
	import Layout from '../components/common/Layout'
	import SectionTitle from "../components/elements/sectionTitle/SectionTitle"
	import BlogSidebar from '../components/blog/BlogSidebar'
	import BlogPost from '../components/blog/BlogPost'
	import BlogPostMixin from '../mixins/BlogPostMixin'
	
	export default {
		name:'EdgeProductsPage',
		components:{
			Layout,SectionTitle,BlogSidebar,BlogPost
		},
		mixins: [BlogPostMixin],
		data(){
			return{
				// edgeProductsIntro:[]
				selectItem:{
					categoryID:'',
            		typeName:''
				},
				// 面包屑数据
				breadList: [
					{
						Label: '首页',
						Url: '/'
					},
					{
						Label: '产品中心',
						Url: '/products'
					}
				],
				// 动画key值（初始值互不相同，避免重复key警告）
				titleAnimationKey: 1,
				searchAnimationKey: 2,
				listAnimationKey: 3,
				// 搜索相关数据
				searchKeyword: '',
				searchResults: [],
				searchLoading: false,
				allProducts: []
			}			
		},
		methods:{
			headClass() {
			  //表头居中显示
			  return "text-align:center ;background-color:#d0f0fc;";
			},
			flush: function() {
				this.$router.go(0);
			},
			// 更新面包屑导航
		updateBreadcrumb(categoryID) {
			if (!categoryID) {
				this.breadList = [
					{ Label: '首页', Url: '/' },
					{ Label: '产品中心', Url: '/products' }
				];
				return;
			}
			this.breadList = [
				{ Label: '首页', Url: '/' },
				{ Label: '产品中心', Url: '/products' }
			];
			// 查找主分类
			const mainItem = this.menuList.find(item => item.slug === categoryID);
			if (mainItem) {
				this.breadList.push({ Label: mainItem.name, Url: '/products/' + mainItem.slug });
				return;
			}
			// 查找二级分类和三级分类
			for (const item of this.menuList) {
				if (item.subItems && item.subItems.length > 0) {
					const subItem = item.subItems.find(s => s.slug === categoryID);
					if (subItem) {
						this.breadList.push({ Label: item.name, Url: '/products/' + item.slug });
						this.breadList.push({ Label: subItem.name, Url: '/products/' + subItem.slug });
						return;
					}
					// 查找三级分类
					for (const sub of item.subItems) {
						if (sub.subItems && sub.subItems.length > 0) {
							const grandItem = sub.subItems.find(g => g.slug === categoryID);
							if (grandItem) {
								this.breadList.push({ Label: item.name, Url: '/products/' + item.slug });
								this.breadList.push({ Label: sub.name, Url: '/products/' + sub.slug });
								this.breadList.push({ Label: grandItem.name, Url: '/products/' + grandItem.slug });
								return;
							}
						}
					}
				}
			}
		},
			// 刷新动画
			refreshAnimations() {
				this.titleAnimationKey++;
				this.searchAnimationKey++;
				this.listAnimationKey++;
				this.$nextTick(() => {
					if (window.AOS) {
						window.AOS.refresh();
					}
				});
			},
			// 刷新列表动画
			refreshListAnimation() {
				this.listAnimationKey++;
			},
			// 点击展开折叠菜单事件
		showToggle: function(item, ind) {

			// 先清除所有菜单项的选中状态和展开状态（三级深度）
			this.menuList.forEach(i => {
				i.isSelected = false;
				if(i.subItems && i.subItems.length>0){
					i.subItems.forEach(j => {
						j.isSelected = false;
						if(j.subItems && j.subItems.length>0){
							j.subItems.forEach(k => {
								k.isSelected = false;
							});
						}
					});
				}
			});

			// 判断点击的是叶子分类还是有子菜单的父分类
			if(item.subItems == undefined || item.subItems.length <= 0){
				// 点击的是叶子分类（没有子菜单的项）
				this.selectItem.categoryID = item.slug;
				this.getCategoriesData(item.slug);
				item.isSelected = true;
				this.updateBreadcrumb(item.slug);
				this.refreshListAnimation();
				this.$router.push('/products/' + item.slug).catch(() => {});
				return;
			}

			// 点击的是有子菜单的父分类
			item.isSelected = true;
			item.isSubShow = true;
			// 加载该分类下所有子分类的产品
			this.selectItem.categoryID = item.slug;
			this.getCategoriesData(item.slug);
			this.updateBreadcrumb(item.slug);
			this.refreshListAnimation();
			this.$router.push('/products/' + item.slug).catch(() => {});

			// 判断item是主分类还是二级分类，关闭同级其他分类的展开
			const isMainCategory = this.menuList.includes(item);
			if (isMainCategory) {
				// 关闭其他主分类的展开
				this.menuList.forEach(i => {
					if (i !== item) {
						i.isSubShow = false;
					}
				});
			} else {
				// 二级分类：关闭同级其他二级分类的展开
				this.menuList.forEach(i => {
					if(i.subItems && i.subItems.length>0){
						i.subItems.forEach(j => {
							if (j !== item && j.subItems) {
								j.isSubShow = false;
							}
						});
					}
				});
			}
		},
		clickRow (row) {

		/* 本来这里是点击行内所有位置都会跳转@row-click，后来感觉不太方便，就改成只有点击图片才会跳转@cell-click */
		this.selectItem.typeName = row.PTName;

		this.$store.state.productBread = this.selectItem;
		// 存储分类面包屑路径，供产品详细页使用
		this.$store.state.productBread.breadPath = JSON.parse(JSON.stringify(this.breadList));
	    this.$router.push("/product-detail/" +row.id);
	},
	clickSell (row, column) {

		this.selectItem.typeName = row.PTName;
		this.$store.state.productBread = this.selectItem;
		// 存储分类面包屑路径，供产品详细页使用
		this.$store.state.productBread.breadPath = JSON.parse(JSON.stringify(this.breadList));

		if(column.label == "产品" || column.label == "型号"){
			this.$router.push("/product-detail/" +row.id);
		}
		},
		HighLightSelectItem (slug){

			// 先清除所有菜单项的选中状态和展开状态（三级深度）
			this.menuList.forEach(i => {
				i.isSelected = false;
				i.isSubShow = false;
				if(i.subItems && i.subItems.length>0){
					i.subItems.forEach(j => {
						j.isSelected = false;
						j.isSubShow = false;
						if(j.subItems && j.subItems.length>0){
							j.subItems.forEach(k => {
								k.isSelected = false;
							});
						}
					});
				}
			});

			// 主分类ID到菜单索引的映射
			const mainCategoryMap = {
				'1': 0,   // 边缘控制器
				'2': 1,   // MAC系列控制器
				'3': 2,   // 分布式控制器
				'4': 3,   // EDC系列
				'5': 4,   // CIO系列
				'6': 5,   // 扩展IO模块
				'7': 6,   // 电源模块
				'8': 7,   // 专用产品
				'9': 8,   // 环网伺服器
				'10': 9,  // 软件产品
			};

			// 查找匹配的菜单项并高亮
			let found = false;
			const mainCategoryIndex = mainCategoryMap[slug];

			// 如果是主分类ID（如 /products/1），高亮该主分类并展开子菜单
			if (mainCategoryIndex !== undefined) {
				const menuItem = this.menuList[mainCategoryIndex];
				menuItem.isSelected = true;
				// 如果有子分类，展开子菜单
				if (menuItem.subItems && menuItem.subItems.length > 0) {
					menuItem.isSubShow = true;
				}
				found = true;
			}

			// 遍历查找子分类和三级分类
			this.menuList.forEach(i => {
				if(i.subItems && i.subItems.length>0){
					i.subItems.forEach(j => {
						if(j.slug == slug){
							i.isSubShow = true;
							j.isSelected = true;
							// 如果二级分类自身有子分类（如MEG系列），也展开其子菜单
							if(j.subItems && j.subItems.length > 0){
								j.isSubShow = true;
							}
							found = true;
						}
						// 三级分类（如 /products/1_2_1）
						if(j.subItems && j.subItems.length>0){
							j.subItems.forEach(k => {
								if(k.slug == slug){
									i.isSubShow = true;
									j.isSubShow = true;
									k.isSelected = true;
									found = true;
								}
							});
						}
					});
				}
			});

			return found;
		},
		
		// 搜索产品
		handleProductSearch(query) {
				if (!query) {
					this.searchResults = [];
					return;
				}
				
				this.searchLoading = true;
				
				// 获取所有产品数据
				if (this.allProducts.length === 0) {
					this.allProducts = this.getAllProducts();
				}
				
				// 过滤匹配的产品
				setTimeout(() => {
					this.searchLoading = false;
					this.searchResults = this.allProducts.filter(product => {
						const keyword = query.toLowerCase();
						const ptName = product.PTName ? product.PTName.toLowerCase() : '';
						return ptName.includes(keyword);
					}).slice(0, 20); // 限制最多显示20条
				}, 200);
			},
			
			// 选择搜索结果
			handleProductSelect(productId) {
				if (!productId) {
					return;
				}
				
				// 找到对应的产品
				const product = this.allProducts.find(p => p.id === productId);
				if (!product) {
					return;
				}
				
				// 获取产品对应的分类ID
				const categoryId = product.categoryId;
				
				// 切换到对应的分类并高亮
				this.selectItem.categoryID = categoryId;
				this.getCategoriesData(categoryId);
				this.HighLightSelectItem(categoryId);
				this.updateBreadcrumb(categoryId);
				this.refreshListAnimation();
				
				// 清空搜索
				this.searchKeyword = '';
				this.searchResults = [];
			},		
		},/* end methods */	
		watch:{
			'$route': {
				handler(to){
					if(to.path.startsWith('/products')){
						const categoryID = to.params.categoryID;
						if(categoryID){
							this.getCategoriesData(categoryID);
							this.HighLightSelectItem(categoryID);
							this.updateBreadcrumb(categoryID);
							this.refreshListAnimation();
						}
					}
				},
				immediate:false,
			}
		},
		beforeRouteEnter (to, from, next) {
			
		    // console.log(`beforeRouteEnter - ${to.path},${to.params.categoryID},${to.path.substring(1,to.path.lastIndexOf('/'))}`);
			
		    		
		    next(obj=>{

				// 这里如果在next外部是无效的，即：this.$store.state.productBread.categoryID，会报错this.$store undefined
				// console.log(`obj.$store.state.productBread.categoryID - ${obj.$store.state.productBread.categoryID}`);

				// 优先使用URL参数，store中的值作为备用（解决从其他页面返回时使用旧值的问题）
				let categoryID = to.params.categoryID;
				if(categoryID == null || categoryID == undefined || categoryID == ""){
					categoryID = obj.$store.state.productBread.categoryID;
					if(categoryID != null && categoryID != undefined && categoryID != ""){
						obj.selectItem = {
							categoryID:categoryID,
							typeName:obj.$store.state.productBread.typeName
						}
					}
				}

				// console.log(`obj.$store.state.productBread.categoryID - ${obj.$store.state.productBread.categoryID}`);
				// console.log(`to.params.categoryID - ${to.params.categoryID}`);
				// console.log(`categoryID - ${categoryID}`);
				

		    	if(to.path.substring(1,to.path.lastIndexOf('/')) == 'products'){
		    		obj.getCategoriesData(categoryID);
		    		obj.HighLightSelectItem(categoryID);
		    		obj.updateBreadcrumb(categoryID);
		    		obj.refreshAnimations();
		    	}
		    });
		},
		// beforeRouteUpdate (to, from, next) {
			  
		// 	console.log(`beforeRouteUpdate - to.path=${to.path},to.params.categoryID=${to.params.categoryID},${to.path.substring(1,to.path.lastIndexOf('/'))}`);
		// 	this.getCategoriesData(to.params.categoryID);
		// 	this.edgeProductsIntroKey = to.params.categoryID;
		// 	console.log(this.edgeProductsIntroKey);
			
		// 	next(obj=>{
		// 		console.log("to.path.substring(1,to.path.lastIndexOf('/')="+to.path.substring(1,to.path.lastIndexOf('/'))));
				
		// 		if(to.path.substring(1,to.path.lastIndexOf('/')) == 'products'){
		// 			this.getCategoriesData(to.params.categoryID);
		// 			console.log(getCategoriesData);
		// 		}
		// 	});
		// }
	}
</script>

<style>	
	table {
		margin: 0 0 !important;
		font-size: 16px;
	}
	/* 左侧产品类型菜单 - 容器总体边距（控制绿框包含标题和整个列表） */
	.widget_categories {
		padding-top: 0 !important;
		padding-bottom: 15px !important;
		padding-left: 0 !important;
		padding-right: 0 !important;
	}
	/* 产品类型标题 - 修复原CSS中 margin: -1px -22px 0 让标题溢出容器的bug */
	.widget_categories .title {
		position: relative !important;
		margin: 0 0 12px !important;        /* 标题横跨整个容器宽度 */
		padding: 14px 24px !important;     /* 标题内边距（保留原值） */
		color: #1E4D7A !important;         /* 标题文字颜色（深蓝） */
		font-size: 18px;
		font-weight: 600;
		border-radius: 4px 4px 0 0;
	}

	/* ===== 父分类容器边距 ===== */
	/* 控制父分类（如"边缘控制器"）与蓝框左右边缘的距离，以及父分类项的上下间距 */
	.category-list > aside > ul > li {
		padding-left: 10px;
		padding-right: 10px;
		padding-top: 0;
		padding-bottom: 0;
	}

	/* ===== 子分类容器边距 ===== */
	/* 控制子分类列表的左缩进距离（相对于父分类） */
	.category-list > aside > ul > li > ul {
		padding-left: 0px;
		padding-right: 15px;
	}
	/* 控制子分类项（如"PAG系列"）自身的上下内边距 */
	.category-list > aside > ul > li > ul > li {
		padding-top: 0;
		padding-bottom: 0;
	}

	/* ===== 孙分类容器边距 ===== */
	/* 控制孙分类列表的左缩进距离（相对于子分类） */
	.category-list > aside > ul > li > ul > li > ul {
		padding-left: 0px;
		padding-right: 15px;
	}
	/* 控制孙分类项（如"主控制器"）自身的上下内边距 */
	.category-list > aside > ul > li > ul > li > ul > li {
		padding-top: 0;
		padding-bottom: 0;
	}
	/* 表格内容字体 */
	.product-table .el-table__body-wrapper td {
		font-size: 14x;
	}
	/* 产品缩略图容器 */
	.product-img-wrapper {
		width: 100%;
		height: 200px;
		overflow: hidden;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	/* 产品缩略图统一大小 */
	.product-thumbnail {
		height: 100%;
		width: auto;
		object-fit: cover;
	}
		/* 手机端产品缩略图大小（屏幕宽度 ≤ 768px 时生效，包含767px边界值） */
	/* 调整方法：修改 .product-img-wrapper 的 height 值可改变图片高度 */
	@media only screen and (max-width: 768px) {
		.product-img-wrapper {
			height: 160px;
		}
		/* 手机端表格列宽重新分配，避免固定宽度过大导致失衡 */
		/* 产品列、型号列、资源列、简介列  */
		.product-table colgroup col:nth-child(1) { width: 25% !important; }
		.product-table colgroup col:nth-child(2) { width: 15% !important; }
		.product-table colgroup col:nth-child(3) { width: 30% !important; }
		.product-table colgroup col:nth-child(4) { width: 30% !important; }
		/* 手机端表格字体缩小，避免文字溢出 */
		.product-table .el-table__body-wrapper td {
			font-size: 12px;
		}
		.product-table th.el-table__cell {
			font-size: 12px;
			padding: 2px 4px !important;
		}
		.product-table .el-table__body-wrapper td {
			padding: 2px 2px !important;
		}
			/* 手机端页面左右边距调整（修改padding值可调整间距） */
		.container {
			padding-left: 10px !important;
			padding-right: 10px !important;
		}
	}
	/* ===== 左侧产品类型菜单 - 三级渐变层级样式 ===== */
	/* 设计原则：层级越深，颜色越浅；父级突出，子级柔和，孙级接近白色 */
	/* 渐变方向统一为 90deg（从左向右），由浅蓝过渡到白色 */

	/* 父层级（主分类）：较明显的浅蓝色，视觉权重最高 */
	.menu-level-1 {
		display: flex;
		justify-content: space-between;
		align-items: center;
		background: linear-gradient(90deg, #E6F0FA 0%, #FFFFFF 100%);
		color: #1E4D7A;
		font-weight: 600;
		font-size: 15px;
		padding: 8px 12px;
		border-radius: 4px;
		cursor: pointer;
		transition: all 0.3s ease;
		position: relative;
		border: 1px solid #D5E5F3;
	}
	.menu-level-1:hover {
		background: linear-gradient(90deg, #D6E0EA 0%, #FFFFFF 100%);
	}
	.menu-level-1 span {
		color: #1E4D7A !important;
	}

	/* 子层级（二级分类）：比父层级更浅，保留淡蓝色识别感 */
	.menu-level-2 {
		display: flex;
		justify-content: space-between;
		align-items: center;
		background: linear-gradient(90deg, #F2F7FD 0%, #FFFFFF 100%);
		color: #325B7E;
		font-weight: 500;
		font-size: 14px;
		padding: 7px 12px;
		margin-top: 4px;
		border-radius: 4px;
		cursor: pointer;
		transition: all 0.3s ease;
		position: relative;
		border: 1px solid #E1EBF4;
	}
	.menu-level-2:hover {
		background: linear-gradient(90deg, #E2E7ED 0%, #FFFFFF 100%);
	}
	.menu-level-2 .menu-text {
		color: #325B7E !important;
	}

	/* 孙层级（三级分类）：非常接近白色，视觉最轻 */
	.menu-level-3 {
		display: flex;
		justify-content: space-between;
		align-items: center;
		background: linear-gradient(90deg, #FAFCFF 0%, #FFFFFF 100%);
		color: #5E6E82;
		font-weight: 500;
		font-size: 13px;
		padding: 6px 12px;
		margin-top: 3px;
		border-radius: 4px;
		cursor: pointer;
		transition: all 0.3s ease;
		position: relative;
		border: 1px solid #E8EEF4;
	}
	.menu-level-3:hover {
		background: linear-gradient(90deg, #EAF0F6 0%, #FFFFFF 100%);
	}
	.menu-level-3 .menu-text {
		color: #5E6E82 !important;
	}

	/* 选中状态：浅蓝背景加深 + 左侧蓝色标识条 + 轻微阴影 */
	.menu-level-1.activeNav,
	.menu-level-2.activeNav,
	.menu-level-3.activeNav {
		background: linear-gradient(90deg, #DCEEFF 0%, #F7FBFF 100%);
		color: #174F7D;
		border: 1px solid #A9CCE8;
		border-left: 4px solid #2D7FC1;
		box-shadow: 0 3px 10px rgba(45, 127, 193, 0.12);
		font-weight: 600;
	}
	.menu-level-1.activeNav span,
	.menu-level-2.activeNav span,
	.menu-level-3.activeNav span {
		color: #174F7D !important;
	}

	/* 左侧层级连接线容器样式 */
	.category-list aside ul {
		list-style: none;
		padding-left: 0;
		margin: 0;
	}
	.category-list aside ul ul {
		padding-left: 0;
		margin-left: 0;
	}
	
	/* 搜索框样式 - 居中显示 */
	.product-search-center {
		display: flex;
		justify-content: center;
		margin-top: 30px;
		margin-bottom: 20px;
	}
	.product-search-center .el-select {
		width: 400px;
	}
	.product-search-center .el-select .el-input__inner {
		border-radius: 4px;
		border-color: #ddd;
		height: 38px;
		line-height: 38px;
	}
	.product-search-center .el-select-dropdown__item {
		height: 36px;
		line-height: 36px;
	}
	.product-search-center .el-select-dropdown__item.selected {
		color: #409EFF;
		font-weight: bold;
	}

	/* 从下向上滑入动画 */
	.slide-up-enter-active {
		transition: all 0.6s ease-out;
	}
	.slide-up-enter-from {
		opacity: 0;
		transform: translateY(40px);
	}
	.slide-up-leave-active {
		display: none;
	}
	.product-list-wrapper {
		width: 100%;
	}
</style>